import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function LocalAreaContent() {
  return <section id="local-area-content" className="w-full bg-background">
      <Separator className="w-full" />
      
      <div className="container mx-auto px-4 py-16 md:py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
            
            <h2 className="mb-8 text-center font-serif text-3xl font-medium tracking-tight text-foreground md:text-4xl lg:text-5xl">
              Serving the Heart of Our Community
            </h2>
            
            <div className="space-y-6 font-sans text-base leading-relaxed text-secondary md:text-lg">
              <p>
                Nestled in the vibrant center of our region, we are deeply committed to supporting the local community that has supported us. Our comprehensive understanding of the area's unique landscape and diverse population allows us to deliver tailored services that truly resonate with the people who live, work, and thrive here.
              </p>
              
              <p>
                Whether you are located in the bustling downtown business districts or the quiet, family-friendly suburban neighborhoods, our dedicated team is always within reach. We believe that accessibility is key to building lasting relationships, which is why we continuously invest in expanding our local presence. For more details on our specific service areas, please visit our <Link to="/ContactPage" className="text-primary underline decoration-primary/30 underline-offset-4 transition-colors hover:decoration-primary">contact and locations</Link> page.
              </p>
              
              <p>
                By choosing a locally-focused provider, you are not just receiving exceptional service; you are investing back into the community. We are proud to partner with local organizations and participate in initiatives that drive positive change and foster a stronger, more connected environment for everyone.
              </p>
            </div>

            <div className="mt-10 flex justify-center">
              <Button asChild variant="outline" size="lg" className="rounded-full px-8">
                <Link to="/OurStoryPage">
                  Discover Our Story
                </Link>
              </Button>
            </div>

          </div>
        </div>
      </div>

      <Separator className="w-full" />
    </section>;
}